import React from 'react';
import styled from 'styled-components';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import { getColor } from 'common/constants/_colors';
import {
  ConnectedState,
  NotSetupState,
  NotActiveState,
  FailedState
} from '../../../authStateBar/connectedAuthStates';
import { SENSOR_STATES } from '@linearb/linjs-common';
import Icon from 'components/base/Icon';

const AuthStateWrapper = styled(Flex)`
  background-color: ${({ bgColor }) => `${getColor(bgColor)}`};
  border: 1px solid ${({ borderColor }) => getColor(borderColor)};
`;

const SingleSignOnState = ({ isSamlSSOActive, sensorState }) => {
  let colors;
  let ConnectionState;

  if (!isSamlSSOActive) {
    colors = {
      backgroundColor: 'bridalHeath',
      border: 'serenade'
    };
    ConnectionState = NotActiveState();
  } else if (sensorState === SENSOR_STATES.ok && isSamlSSOActive) {
    colors = {
      backgroundColor: 'fetaLight',
      border: 'feta'
    };
    ConnectionState = ConnectedState();
  } else if (sensorState === SENSOR_STATES.failing && isSamlSSOActive) {
    colors = {
      backgroundColor: 'bridalHeath',
      border: 'serenade'
    };
    ConnectionState = FailedState();
  } else {
    colors = {
      backgroundColor: 'catskillGray',
      border: 'catskillWhite'
    };
    ConnectionState = NotSetupState();
  }

  return (
    <AuthStateWrapper
      items='center'
      grow='1'
      padding='small'
      mb='medium'
      minHeight='3.4rem'
      justify='space-between'
      bgColor={colors.backgroundColor}
      borderColor={colors.border}
    >
      <Flex items='center' grow='1'>
        <Flex pr='small' pl='x-small'>
          <Icon name='VPNKey' size='normal'></Icon>
        </Flex>
        <Text size='x-large'>Single Sign-On</Text>
        {ConnectionState}
      </Flex>
    </AuthStateWrapper>
  );
};

export default SingleSignOnState;
